import { Box } from "@mui/material";
import { useSnackbar } from "notistack";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "../../app/helpers";
import AdminSelectionLocation from "../../components/Pickers/admin-selection-location.component";
import AdminSelection from "../../components/Pickers/admin-selection.component";
import { getAllUsers } from "../../utils/axios-requests";
import { UserOrEmailMapping } from "./typings/admin.types";
import { RootState } from "../../app/rootReducer";
import { BookingType } from "../Booking-Form/typings/booking-inputs";
import { selectVisitorManagementEnabled } from "../Login/selectors/selectVisitorManagementEnabled";

/**
 * @description Component that renders the admins interface.
 * @version 0.2.1
 */
const AdminsAdministration = () => {
  const { t } = useTranslation();
  const { enqueueSnackbar } = useSnackbar();

  const {
    userRoles: { isTenantAdmin, isCompanyAdmin },
    userInformation: { placeTypes }
  } = useSelector((state: RootState) => state.login);

  const hasVehicleLicense = placeTypes.some(type => type.name === BookingType.VEHICLE);
  const visitorManagementEnabled = useSelector(selectVisitorManagementEnabled);

  const [users, setUsers] = useState<UserOrEmailMapping[]>([]);

  useEffect(() => {
    const getUsers = async () => {
      try {
        const allUsers = await getAllUsers();
        setUsers(allUsers.data ?? []);
      } catch (err) {
        console.warn(err);
        enqueueSnackbar(t("There was a problem getting all users"), {
          variant: "error"
        });
      }
    };
    getUsers();
  }, [enqueueSnackbar, t]);

  return (
    <Box display="flex" flexWrap="wrap">
      {/* Company Admin */}
      {isTenantAdmin && <AdminSelection options={users} adminMode={"Company Admin"} />}

      {isCompanyAdmin && (
        <>
          {/* HR Admin */}
          <AdminSelection options={users} adminMode={"HR Admin"} />

          {/* Location Admin */}
          <AdminSelectionLocation options={users} adminMode={"Location Admin"} />

          {/* Service Admin */}
          <AdminSelectionLocation options={users} adminMode={"Service Admin"} />

          {/* Capacity Responsible */}
          <AdminSelectionLocation options={users} adminMode={"Capacity Responsible"} />

          {/* Equipment Admin */}
          <AdminSelection options={users} adminMode={"Equipment Admin"} />

          {/* Fleet Admin */}
          {hasVehicleLicense && <AdminSelection options={users} adminMode={"Fleet Admin"} />}

          {/* Visitor Admin */}
          {visitorManagementEnabled && (
            <AdminSelectionLocation options={users} adminMode={"Visitor Admin"} />
          )}
        </>
      )}
    </Box>
  );
};

export default AdminsAdministration;
